// like !default / !edit / %21viewLogs
import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecuritySchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-schemes',
	path: '/secure/admin/ViewIssueSecuritySchemes([!%]?[\\w]*).jspa',
};
